import { SearchTeamMembersParams } from 'ProfileModule/types';

// Map a sortable table column id to the Rails team_memberships/search `sort`
// key (GLX-1740). Columns not listed here (checkbox/copy/impersonation/is_admin)
// are not server-sortable.
const SORT_FIELD_BY_COLUMN: Record<string, SearchTeamMembersParams['sort']> = {
  account_id: 'account_id',
  name: 'name',
  email: 'email',
  role_name: 'role',
  last_active: 'last_active',
  is_active: 'is_activated',
};

export const resolveSortField = (columnId: string): NonNullable<SearchTeamMembersParams['sort']> =>
  SORT_FIELD_BY_COLUMN[columnId] ?? 'account_id';

// Smart single search box. The endpoint exposes separate name / email /
// account_ids filters (AND-combined) rather than one cross-field OR search, so
// we route the typed text to the most likely field:
//   - contains "@"   -> email   (partial match)
//   - all digits     -> account_ids (exact match)
//   - anything else  -> name    (matches first / last / full name)
export const buildTeamMembersSearchParams = (
  raw: string,
): Pick<SearchTeamMembersParams, 'name' | 'email' | 'account_ids'> => {
  const q = raw.trim();
  if (!q) return {};
  if (q.includes('@')) return { email: q };
  if (/^\d+$/.test(q)) return { account_ids: [Number(q)] };
  return { name: q };
};
